import {
    back,
    replace
} from '../../actions';
import { AppHeader } from '../../combo';
import {
    BigButton,
    Logo,
    Page,
    React,
    Title
} from '../../common';
import { COUNTRY_CODE } from '../../config';
import { syncUserState } from '../../init';
import { getUserLoadingState } from '../../selectors';
import { storage } from '../../services/localstorage';
import { initUserProfile } from '../../services/user.utils';
import { useBackHandler } from '../../utils/routing';

export const AccountReset = Page.register(
    ({
        route: {
            params: {
                navigatedFromScreen,
                deviceIdOfExistedUser,
            },
        },
        isLoading,
        setState,
        navigation,
        phonePrefix = COUNTRY_CODE,
        phoneNumber = '',
        error,
        isAgree,
        onDidMount = () => storage.getObject('phoneNumber', '')
            .then((phone) => setState({ phoneNumber: phone })),
        onSubmit = async () => {
            const result = await initUserProfile(deviceIdOfExistedUser || true);
            // await api.updateUserInfo({ consentReceived: true });
            if (result instanceof Error) {
                setState({ error: result });
            } else {
                await syncUserState();
                if (navigatedFromScreen === 'Account' || navigatedFromScreen === 'AccessCheck') {
                    navigation.replace('ChooseProgram');
                    setTimeout(() => navigation.navigate('ConsentsScreen'), 0);
                } else {
                    navigation.replace('Account');
                    navigation.navigate('ChooseProgram');     
                               
                    setTimeout(() => navigation.navigate('ConsentsScreen'), 0);
                }
            }
        },
    }) => {
        const backHandler = React.useCallback(
            () => (navigatedFromScreen === 'Account' ? back() : replace(navigatedFromScreen)),
            [ navigatedFromScreen ],
        );
        useBackHandler(backHandler);
        return (
            <Page
                name="reset-account"
                isLoading={isLoading}
                onDidMount={onDidMount}
                notification={error}
                safeArea
            >
                <Logo.Wrapper
                    wrapperStyle={{
                        marginTop: 16,
                        padding: 8,
                        alignItems: 'center',
                    }}
                >
                    <Title
                        bold
                        centered
                        id="titles.creatingNewProfileForNumber"
                        style={{
                            marginTop: 32,
                            fontSize: 18,
                        }}
                    />
                    <Title style={{ marginTop: 18 }}>{`${phonePrefix} ${phoneNumber}`}</Title>
                    <Title
                        id="titles.userWithNumberWasRegistered"
                        style={{
                            color: '#BBBBBB',
                            textAlign: 'center',
                            marginTop: 8,
                        }}
                    />
                    <Title
                        id="titles.canCreateProfileIfNumberOwner"
                        style={{
                            color: '#BBBBBB',
                            textAlign: 'center',
                            marginTop: 24,
                        }}
                    />
                    {/* <View style={{ width: '100%' }}>
                        <Agreements
                            userAgreement
                            personalDataAgreement
                            onChange={(agree) => setState({ isAgree: agree })}
                        />
                    </View> */}
                    <BigButton
                        title="buttons.createNewProfile"
                        action={onSubmit}
                        styles={{ marginTop: 36 }}
                        // disabled={!isAgree}
                        // disabledStyle={{ marginTop: 36 }}
                    />
                </Logo.Wrapper>
            </Page>
        );
    },
    { isLoading: { from: getUserLoadingState } },
    ({
        navigation,
        route: { params = {} },
    }) => ({
        header: () => (
            <AppHeader
                navigation={navigation}
                backPress={() =>
                    params.navigatedFromScreen === 'Account' ? back() : replace(params.navigatedFromScreen)
                }
            />
        ),
    }),
);
